import React, { useCallback, useMemo } from 'react';
import PermissionContext from './permission-context';

type Props = {
    permissions: string[]|undefined,
    children : any
}

const PermissionProvider: React.FunctionComponent<Props> = ({permissions, children}) => {
    const isAllowedTo = useCallback(
        (cPermissions: string[]|undefined): boolean|undefined => permissions?.some((permission) => cPermissions?.includes(permission)),
        [permissions]
    );
    const contextValue = useMemo(() => ({isAllowedTo}), [isAllowedTo]);
    return <PermissionContext.Provider value={contextValue}>{children}</PermissionContext.Provider>;
};

export default PermissionProvider;